import { render } from "./ActionSection.vue?vue&type=template&id=3c850014"
import script from "./ActionSection.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionSection.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/ActionSection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c850014"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c850014', __exports__)) {
    api.reload('3c850014', __exports__)
  }
  
  module.hot.accept("./ActionSection.vue?vue&type=template&id=3c850014", () => {
    api.rerender('3c850014', render)
  })

}


export default __exports__